import React from 'react';
import Pais from '../../components/pais/Pais';
import Layout from '../../components/layout/Layout';

const PaisPage = () => {
    return ( <Layout children={<Pais />} /> )
}

export default PaisPage